import { defineComponent as _defineComponent } from 'vue'
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import KpiWidget from '../common/KpiWidget.vue';
import { KpiWidgetData } from '@/models/Charts/chartsData';
import { kilogramsToCustomerUnit, weightUnit } from '@/utils/measurement';
import { computed } from 'vue';
import {
  TrendData,
  getTrendDataFromPieWidgetData,
} from '@/components/bend/kpiWidgetUtils';
import { useI18n } from '@/composables/i18n';
import { abbreviateNumberWithUnit } from '@/utils/number';


/**
 * Shows the total weight produced and a pie chart with produced weight per
 * device.
 *
 * The total weight is shown with the trend as a percentage difference in
 * respect to the weight produced in the previous period
 * (widgetDefinition.timeFilter).
 *
 * On the pie chart is the weight percentage for the device for the current
 * period.
 *
 * The weights are shown in the unit configured by the customer.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'BendProductionOutputWidget',
  props: {
    data: null,
    generator: null,
    widgetDefinition: null,
    loading: { type: Boolean },
    isFetchingForTheFirstTime: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  data: KpiWidgetData[] | null;
  generator: ChartGenerator<KpiWidgetData>;
  widgetDefinition: WidgetDefinition;
  loading: boolean;
  isFetchingForTheFirstTime: boolean;
};



const { t } = useI18n();

const unitConvertedData = computed(
  () =>
    props.data?.map((dataItem) => ({
      ...dataItem,
      currentValue: kilogramsToCustomerUnit(dataItem.currentValue),
      previousValue: kilogramsToCustomerUnit(dataItem.previousValue),
    })) ?? null,
);

const trendData = computed<TrendData | null>(() =>
  getTrendDataFromPieWidgetData(
    props.data,
    props.widgetDefinition.timeFilterEnumValue!,
  ),
);

const unit = computed(() => weightUnit());

return { __sfc: true,props, t, unitConvertedData, trendData, unit, KpiWidget, abbreviateNumberWithUnit }
}

})